import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import bccy1 from '../imagenes/logo1.svg';

function Navbar() {
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);

  const closeMobileMenu = () => {
    setClick(false);
    setDropdown(null);
  };

  const handleClick = () => {
    setClick(!click);
    setDropdown(null);
  };

  const toggleDropdown = (name) => {
    setDropdown(dropdown === name ? null : name);
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setDropdown(null);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = click ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [click]);

  const navClass = scrolled ? 'navbar navbar--scrolled' : 'navbar';
  const menuClass = click ? 'nav-menu active' : 'nav-menu';

  return (
    <nav className={navClass} ref={navRef}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src={bccy1} className="navbar-logo-image" alt="BCCY" />
        </Link>

        <button type="button" className="menu-icon" onClick={handleClick} aria-label="Menu">
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <ul className={menuClass}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={closeMobileMenu}>
              Inicio
            </Link>
          </li>

          <li className="nav-item">
            <a className="nav-links" href="/docs/NORMATIVIDAD.pdf" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
              Normatividad
            </a>
          </li>

          <li className="nav-item">
            <button
              type="button"
              className={dropdown === 'resoluciones' ? 'nav-links nav-toggle is-open' : 'nav-links nav-toggle'}
              onClick={() => toggleDropdown('resoluciones')}
            >
              Resolución
              <i className="fas fa-chevron-down nav-caret" />
            </button>

            <ul className={dropdown === 'resoluciones' ? 'dropdown-menu dropdown-menu--wide show' : 'dropdown-menu dropdown-menu--wide'}>
              <li>
                <a href="/docs/RESOLUCION.pdf" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                  Resolución
                </a>
              </li>
              <li>
                <a href="/docs/PR-CM-01_PROCEDIMIENTO_DE_CAMBIO_DE_COMERCIALIZADOR.pdf" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                  Procedimiento cambio comercializador
                </a>
              </li>
              <li>
                <a href="/docs/BCCYOPINION2025.pdf" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                  Opinión auditoría externa BCCY
                </a>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <Link to="/quienes-somos" className="nav-links" onClick={closeMobileMenu}>
              Quiénes Somos
            </Link>
          </li>

          <li className="nav-item">
            <button
              type="button"
              className={dropdown === 'contacto' ? 'nav-links nav-toggle is-open' : 'nav-links nav-toggle'}
              onClick={() => toggleDropdown('contacto')}
            >
              Contáctenos
              <i className="fas fa-chevron-down nav-caret" />
            </button>

            <ul className={dropdown === 'contacto' ? 'dropdown-menu show' : 'dropdown-menu'}>
              <li>
                <Link to="/contactc" onClick={closeMobileMenu}>
                  Córdoba
                </Link>
              </li>
              <li>
                <Link to="/contacth" onClick={closeMobileMenu}>
                  Holding
                </Link>
              </li>
            </ul>
          </li>
        </ul>

        <div
          className={click ? 'nav-backdrop show' : 'nav-backdrop'}
          onClick={closeMobileMenu}
        />
      </div>
    </nav>
  );
}

export default Navbar;